module.exports = "/post_box_new-bbf4548b75c98a9ee4501ebb1f4bf379.svg";